import Arrowright from "@website/icons/components/arrowright";
import { Button } from "@website/ui-old/button";
import {
  Actions,
  Input,
  MonthActions
} from "@website/ui-old/datepicker/components";
import styles from "@website/ui-old/datepicker/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/ui-old/datepicker/components/header/header.types";
import { TopAppBar } from "@website/ui-old/top-app-bar";
import { FC, memo } from "react";

const WEEK_ABBR: Record<string, Array<string>> = {
  persian: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
  gregorian: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
};

const Header: FC<HeaderPropertiesType> = (properties) => {
  const {
    calendarLocale = "gregorian",
    showDates,
    inputProperties,
    scrolled,
    onClose,
    showToday,
    changeCalendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled
  } = properties;

  return (
    <div
      className={`${styles["header"]} ${styles["rtl" || "ltr"]} ${
        scrolled ? styles["scrolled"] : ""
      }`}
    >
      {!scrolled && (
        <div className={styles["top-app-bar"]}>
          <TopAppBar
            StartAction={
              <Button
                EndIcon={<Arrowright />}
                color="neutral"
                equalDimension
                onClick={onClose}
                variant="text"
              />
            }
            title="انتخاب تاریخ"
          />
        </div>
      )}
      <div className={styles["part-one"]}>
        {!scrolled && (
          <Actions
            calendarLocale={calendarLocale}
            changeCalendarLocale={changeCalendarLocale}
            showToday={showToday}
          />
        )}
        <div className={styles["input-container"]}>
          <Input {...inputProperties} disabled={false} fullWidth />
        </div>
      </div>
      <MonthActions
        calendarLocale={calendarLocale}
        nextMonthDisabled={nextMonthDisabled}
        previousMonthDisabled={previousMonthDisabled}
        showDates={showDates}
        showNextMonth={showNextMonth}
        showPreviousMonth={showPreviousMonth}
      />
      <div className={styles["week-names-container-mobile"]}>
        {[1, 2, 3, 4, 5, 6, 7].map((item, index) => (
          <div
            className={styles["week-name"]}
            key={`datepicker-header-${index++}`}
          >
            {WEEK_ABBR[calendarLocale]?.[item - 1] ||
              WEEK_ABBR.gregorian[item - 1]}
          </div>
        ))}
      </div>
    </div>
  );
};

const HeaderMemoized = memo(Header);
/**
 * @deprecated please use @website/ui instead
 */
export { HeaderMemoized /**
 * @deprecated please use @website/ui instead
 */ as Header };
